import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VorratsTabelle from './components/VorratsTabelle';
import NeuesProduktFormular from './components/NeuesProduktFormular';
import BearbeitenFormular from './components/BearbeitenFormular';
import VorratsInventurTabelle from './components/VorratsInventurTabelle';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<VorratsTabelle />} />
        <Route path="/bearbeiten/:id" element={<BearbeitenFormular />} />
        <Route path="/neu" element={<NeuesProduktFormular />} />
        <Route path="/inventur" element={<VorratsInventurTabelle />} />
      </Routes>
    </Router>
  );
}

export default App;
